const AnimatedCounterHook = {
  mounted() {
    const delay = parseInt(this.el.dataset.delay || "0", 10);

    if (delay > 0) {
      this.delayTimer = setTimeout(() => this.animateCounter(), delay);
    } else {
      this.animateCounter();
    }
  },

  updated() {
    this.animateCounter();
  },

  destroyed() {
    clearTimeout(this.delayTimer);
  },

  animateCounter() {
    const el = this.el;
    const targetText = el.dataset.target || el.innerText;
    const duration = parseInt(el.dataset.duration || "2000", 10);

    // Extract the numeric value and preserve the format (e.g., "$1,234")
    const prefix = targetText.match(/^[^0-9]*/)?.[0] || "";
    const suffix = targetText.match(/[^0-9]*$/)?.[0] || "";
    const numericString = targetText.replace(/[^0-9]/g, "");
    const targetValue = parseInt(numericString, 10);

    if (isNaN(targetValue)) return;

    const startTime = performance.now();
    // innerText is already formatted (e.g. "1,234"), so strip the separators
    const startValue = parseInt(el.innerText.replace(/[^0-9]/g, ""), 10) || 0;

    if (startValue === targetValue) return;

    const formatNumber = (num) => {
      return num.toLocaleString("en-US");
    };

    const animate = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);

      // Ease out cubic for smooth deceleration
      const easeOut = 1 - Math.pow(1 - progress, 3);

      const currentValue = Math.floor(
        startValue + (targetValue - startValue) * easeOut,
      );
      el.innerText = prefix + formatNumber(currentValue) + suffix;

      if (progress < 1) {
        requestAnimationFrame(animate);
      } else {
        // Ensure we end with the exact target value, properly formatted
        el.innerText = prefix + formatNumber(targetValue) + suffix;
      }
    };

    requestAnimationFrame(animate);
  },
};

export default AnimatedCounterHook;
